<template>
  <v-snackbar
    v-model="show"
    :top="position === 'top'"
    :bottom="position === 'bottom'"
    :centered="position === 'centered'"
    :color="color"
    :timeout="timeout"
    :multi-line="multiLine"
    class="snack-bar"
  >
    {{ message }}
    <v-btn text color="#FFFFFF" @click.native="show = false">
      <v-icon large>mdi-close-circle-outline</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      show: false,
      message: "",
      position: "",
      // multiLine: true, //multiLine propety extends snackbar height
      multiLine: false,
      color: "green",
      timeout: 5000, //max 5000 milliseconds
    };
  },
  methods: {
    ...mapMutations("users", ["SET_SNACK_IS_BLOCKED"]),
  },
  created: function () {
    this.$store.watch(
      (state) => state.snackbar.snack,
      () => {
        const msg = this.$store.state.snackbar.snack;
        const isError = this.$store.state.snackbar.isError;
        const position = this.$store.state.snackbar.position;
        const isBlocked = this.$store.state.snackbar.isBlocked;
        const snackIsBlocked = this.$store.state.users.snackIsBlocked;
        // console.log(`### snackbar snackIsBlocked: `, snackIsBlocked);
        // console.log(`### snackbar isBlocked: `, isBlocked);

        if (isBlocked) this.SET_SNACK_IS_BLOCKED(isBlocked);

        if (msg !== "" && !snackIsBlocked) {
          this.show = true;
          this.message = msg;

          // this.color = this.$store.state.snackbar.snack.color;
          this.color = !!isError ? "red" : "green";
          this.timeout = !!isError ? 10000 : 5000;

          // position
          this.position = position ? position : "top";

          const setSnackObj = {
            message: "",
            isError: false,
            position: this.position,
            isBlocked: false,
          };
          // console.log(`### snackbar setSnackObj: `, setSnackObj);
          this.$store.commit("setSnack", setSnackObj);
        }
      }
    );
  },
};
</script>

<style lang="scss" scoped>
.snack-bar {
  top: 120px;
}

.v-snack__content {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 16px;
  padding-left: 16px;
}

::v-deep .v-snack__content {
  flex-grow: 1;
  font-size: 1.1rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.0178571429em;
  line-height: 1.35rem !important;
  margin-right: auto;
}
</style>